import { ValueAdapter } from './../value.adapter';
import { toArgsArray, toArgsString } from 'app/model/adapters/activities/arguments-adapter.util';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { ActivityAsyncAdapter } from './activity.adapter';
import { SparkActivity } from 'app/model/pipeline/spark.activity';

import { IModel } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { AzureStorageLinkedService } from 'app/model/linkedservice/azure-storage.linkedservice';
import { HDInsightLinkedService } from 'app/model/linkedservice/hdinsight.linkedservice';
import { ReferenceAdapter } from '../reference.adapter';
import { toParameterClass, toParameterObject } from 'app/model/adapters/linkedservices/parameter-config.util';
import _ from 'lodash';
import { LinkedService } from 'app/model/linkedservice/linkedservice';
import { linkedServiceReferenceWithoutParameterizationRemainer } from '../reference-remainer';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(SparkActivity),
    asynchronous: true,
    adapts: {
        name: '*',
        description: '*',
        type: '*',
        linkedServiceName: linkedServiceReferenceWithoutParameterizationRemainer,
        policy: '*',
        dependsOn: '*',
        userProperties: '*',
        typeProperties: {
            rootPath: '*',
            entryFilePath: '*',
            arguments: '*',
            getDebugInfo: '*',
            className: '*',
            proxyUser: '*',
            sparkJobLinkedService: linkedServiceReferenceWithoutParameterizationRemainer,
            sparkConfig: '*'
        }
    }
})
export class HDInsightSparkActivityAdapter extends ActivityAsyncAdapter<SparkActivity, Model.HDInsightSparkActivity> {

    public model(): IModel {
        return Metamodel.modelFor(SparkActivity);
    }

    protected async _toResource(activity: SparkActivity): Promise<Model.HDInsightSparkActivity> {
        const modelHDInsightSparkActivity: Model.HDInsightSparkActivity = super._getCommonActivityProperties(activity, 'HDInsightSpark') as Model.HDInsightSparkActivity;
        const sparkActivity: SparkActivity = activity as SparkActivity;

        // TODO - ans - Fill these value.
        modelHDInsightSparkActivity.typeProperties = {
            // TODO - ans - make rootPath and entryFilePath nullable.
            rootPath: ValueAdapter.toResource(sparkActivity, SparkActivity.ROOT_PATH),
            entryFilePath: ValueAdapter.toResource(sparkActivity, SparkActivity.ENTRY_FILE_PATH),
            arguments: toArgsArray(sparkActivity.sparkActivityArguments, sparkActivity, SparkActivity.ARGUMENTS),
            getDebugInfo: sparkActivity.getDebugInfo,
            className: sparkActivity.configType === 'Jar' ? sparkActivity.className : undefined,
            proxyUser: ValueAdapter.toResource(sparkActivity, SparkActivity.PROXY_USER),
            sparkConfig: toParameterObject(sparkActivity.sparkConfig)
        };

        if (sparkActivity.sparkJobLinkedService) {
            modelHDInsightSparkActivity.typeProperties.sparkJobLinkedService = this._toLinkedServiceReferenceModel(sparkActivity.sparkJobLinkedService);
        }

        if (sparkActivity.linkedService) {
            modelHDInsightSparkActivity.linkedServiceName = this._toLinkedServiceReferenceModel(sparkActivity.linkedService);
        }

        if (activity.raw) {
            const parsed = JSON.parse(activity.raw);
            // Overlay this on spark activity
            _.merge(modelHDInsightSparkActivity, parsed);
        }
        // TODO - ans - remaining properties
        // proxyUser

        return modelHDInsightSparkActivity;
    }

    protected async _toModel(modelActivity: Model.HDInsightSparkActivity): Promise<SparkActivity> {
        const activity: SparkActivity = SparkActivity.MODEL.create<SparkActivity>(modelActivity.name);
        const modelSparkActivity = modelActivity as Model.HDInsightSparkActivity;

        this._updatedCommonProperties(modelActivity, activity);
        activity.configType = 'Script';

        if (modelSparkActivity.typeProperties) {
            ValueAdapter.toModel(activity, SparkActivity.ROOT_PATH, modelSparkActivity.typeProperties.rootPath);
            ValueAdapter.toModel(activity, SparkActivity.ENTRY_FILE_PATH, modelSparkActivity.typeProperties.entryFilePath);
            const args = toArgsString(activity, modelSparkActivity.typeProperties.arguments, SparkActivity.ARGUMENTS);
            if (args) {
                activity.sparkActivityArguments = args;
            }
            activity.className = modelSparkActivity.typeProperties.className;
            activity.getDebugInfo = modelSparkActivity.typeProperties.getDebugInfo;
            activity.sparkConfig = toParameterClass(modelSparkActivity.typeProperties.sparkConfig, activity);
            ValueAdapter.toModel(activity, SparkActivity.PROXY_USER, modelSparkActivity.typeProperties.proxyUser);
            if (modelSparkActivity.typeProperties.sparkJobLinkedService !== undefined) {
                activity.sparkJobLinkedService = ReferenceAdapter.toProxyModel<AzureStorageLinkedService>(Metamodel.modelFor(AzureStorageLinkedService),
                    modelSparkActivity.typeProperties.sparkJobLinkedService, this.context);
            }
        }

        if (modelSparkActivity.linkedServiceName !== undefined) {
            activity.linkedService = ReferenceAdapter.toProxyModel<LinkedService>(Metamodel.modelFor(HDInsightLinkedService),
                modelSparkActivity.linkedServiceName, this.context);
        }

        if (activity.className != null) {
            activity.configType = 'Jar';
        }

        // TODO - ans - remaining properties
        // proxyUser

        activity.raw = JSON.stringify(await ValueAdapter.remainder(this.context, modelSparkActivity, SparkActivity.MODEL));

        return activity;
    }
}
